import { Action } from '@ngrx/store';
import { Booking } from '../../booking/models/booking';

export const GET_BOOKINGS = '[Booking] Get Bookings';
export const GET_BOOKINGS_SUCCESS = '[Booking] Get Bookings Success';
export const GET_BOOKINGS_FAIL = '[Booking] Get Bookings Fail';

// export const GET_CURRENT_BOOKING = '[Booking] Get Current Booking';
// export const GET_CURRENT_BOOKING_SUCCESS =
//   '[Booking] Get Current Booking Success';
// export const GET_CURRENT_BOOKING_FAIL = '[Booking] Get Current Booking Fail';

export const ADD_BOOKING = '[Booking] Add Booking';
export const ADD_BOOKING_SUCCESS = '[Booking] Add Booking Success';
export const ADD_BOOKING_FAIL = '[Booking] Add Booking Fail';

// export const GO_TO_ADD_BOOKING_VIEW = '[Booking] Go To Add Booking View';

export const DELETE_BOOKING = '[Booking] Delete Booking';
export const DELETE_BOOKING_SUCCESS = '[Booking] Delete Booking Success';
export const DELETE_BOOKING_FAIL = '[Booking] Delete Booking Fail';

// export const EDIT_BOOKING = '[Booking] Edit Booking';
// export const EDIT_BOOKING_SUCCESS = '[Booking] Edit Booking Success';
// export const EDIT_BOOKING_FAIL = '[Booking] Edit Booking Fail';

export const VIEW_BOOKING_DETAIL = '[Booking] View Booking Detail';

// export const COLLECT_SELECTED_ROOM = '[Booking] Collect Selected Room';
// export const COLLECT_SELECTED_TOURS = '[Booking] Collect Selected Tours';

export const INCLUDE_NGYN_CONFERENCE = '[Rooms] Include Ngyn Conference';
export const EXCLUDE_NGYN_CONFERENCE = '[Rooms] Exclude Ngyn Conference';

export const INCLUDE_SOWETO_TOUR = '[Rooms] Include Soweto Tour';
export const INCLUDE_UNION_BUILDING_TOUR =
  '[Rooms] Include Union Building Tour';
export const INCLUDE_SUN_CITY_TOUR = '[Rooms] Include Sun City Tour';
export const INCLUDE_GOLD_REEF_CITY_TOUR =
  '[Rooms] Include Gold Reef City Tour';

export const EXCLUDE_SOWETO_TOUR = '[Rooms] Exclude Soweto Tour';
export const EXCLUDE_UNION_BUILDING_TOUR =
  '[Rooms] Exclude Union Building Tour';
export const EXCLUDE_SUN_CITY_TOUR = '[Rooms] Exclude Sun City Tour';
export const EXCLUDE_GOLD_REEF_CITY_TOUR =
  '[Rooms] Exclude Gold Reef City Tour';

// BOOKING FLOW...
export const ADD_PERSONAL_INFO = '[Booking] Add Personal Info';
export const ADD_CONFERENCE_INFO = '[Booking] Add Conference Info';
export const ADD_ACCOMMODATION_INFO = '[Booking] Add Accommodation Info';
export const ADD_ROOM_INFO = '[Booking] Add Room Info';

export const RESET_CURRENT_BOOKING = '[Booking] Reset Current Booking';

export class GetBookings implements Action {
  readonly type = GET_BOOKINGS;
}

export class GetBookingsSuccess implements Action {
  readonly type = GET_BOOKINGS_SUCCESS;
  constructor(public payload: any) {}
}

export class GetBookingsFail implements Action {
  readonly type = GET_BOOKINGS_FAIL;
  constructor(public payload: any) {}
}

// export class GetCurrentBooking implements Action {
//   readonly type = GET_CURRENT_BOOKING;
//   constructor(public payload: string) {}
// }

// export class GetCurrentBookingSuccess implements Action {
//   readonly type = GET_CURRENT_BOOKING_SUCCESS;
//   constructor(public payload: any) {}
// }

// export class GetCurrentBookingFail implements Action {
//   readonly type = GET_CURRENT_BOOKING_FAIL;
//   constructor(public payload: any) {}
// }

export class AddBooking implements Action {
  readonly type = ADD_BOOKING;
  constructor(public payload: any) {}
}

export class AddBookingSuccess implements Action {
  readonly type = ADD_BOOKING_SUCCESS;
  constructor(public payload: any) {}
}

export class AddBookingFail implements Action {
  readonly type = ADD_BOOKING_FAIL;
  constructor(public payload: any) {}
}

// export class GoToAddBookingView implements Action {
//   readonly type = GO_TO_ADD_BOOKING_VIEW;
// }

export class DeleteBooking implements Action {
  readonly type = DELETE_BOOKING;
  constructor(public payload: string) {}
}

export class DeleteBookingSuccess implements Action {
  readonly type = DELETE_BOOKING_SUCCESS;
  constructor(public payload: any) {}
}

export class DeleteBookingFail implements Action {
  readonly type = DELETE_BOOKING_FAIL;
  constructor(public payload: any) {}
}

// export class EditBooking implements Action {
//   readonly type = EDIT_BOOKING;
//   constructor(public payload: any) {}
// }

// export class EditBookingSuccess implements Action {
//   readonly type = EDIT_BOOKING_SUCCESS;
//   constructor(public payload: any) {}
// }

// export class EditBookingFail implements Action {
//   readonly type = EDIT_BOOKING_FAIL;
//   constructor(public payload: any) {}
// }

export class ViewBookingDetail implements Action {
  readonly type = VIEW_BOOKING_DETAIL;
  constructor(public payload: any) {}
}

// export class CollectSelectedRoom implements Action {
//   readonly type = COLLECT_SELECTED_ROOM;
//   constructor(public payload: any) {}
// }

// export class CollectSelectedTours implements Action {
//   readonly type = COLLECT_SELECTED_TOURS;
//   constructor(public payload: any) {}
// }

export class IncludeNgynConference implements Action {
  readonly type = INCLUDE_NGYN_CONFERENCE;
}

export class ExcludeNgynConference implements Action {
  readonly type = EXCLUDE_NGYN_CONFERENCE;
}

export class IncludeSowetoTour implements Action {
  readonly type = INCLUDE_SOWETO_TOUR;
}

export class IncludeUnionBuildingTour implements Action {
  readonly type = INCLUDE_UNION_BUILDING_TOUR;
}

export class IncludeSunCityTour implements Action {
  readonly type = INCLUDE_SUN_CITY_TOUR;
}

export class IncludeGoldReefCityTour implements Action {
  readonly type = INCLUDE_GOLD_REEF_CITY_TOUR;
}

export class ExcludeSowetoTour implements Action {
  readonly type = EXCLUDE_SOWETO_TOUR;
}

export class ExcludeUnionBuildingTour implements Action {
  readonly type = EXCLUDE_UNION_BUILDING_TOUR;
}

export class ExcludeSunCityTour implements Action {
  readonly type = EXCLUDE_SUN_CITY_TOUR;
}

export class ExcludeGoldReefCityTour implements Action {
  readonly type = EXCLUDE_GOLD_REEF_CITY_TOUR;
}

//
export class AddPersonalInfo implements Action {
  readonly type = ADD_PERSONAL_INFO;
  constructor(public payload: any) {}
}

export class AddConferenceInfo implements Action {
  readonly type = ADD_CONFERENCE_INFO;
  constructor(public payload: any) {}
}

export class AddAccommodationInfo implements Action {
  readonly type = ADD_ACCOMMODATION_INFO;
  constructor(public payload: any) {}
}

export class AddRoomInfo implements Action {
  readonly type = ADD_ROOM_INFO;
  constructor(public payload: any) {}
}

export class ResetCurrentBooking implements Action {
  readonly type = RESET_CURRENT_BOOKING;
}

export type bookingActions =
  | GetBookings
  | GetBookingsSuccess
  | GetBookingsFail
  // | GetCurrentBooking
  // | GetCurrentBookingSuccess
  // | GetCurrentBookingFail
  // | CollectSelectedRoom
  // | CollectSelectedTours
  | IncludeNgynConference
  | ExcludeNgynConference
  | IncludeSowetoTour
  | IncludeUnionBuildingTour
  | IncludeSunCityTour
  | IncludeGoldReefCityTour
  | ExcludeSowetoTour
  | ExcludeUnionBuildingTour
  | ExcludeSunCityTour
  | ExcludeGoldReefCityTour
  | AddBooking
  | AddBookingSuccess
  | AddBookingFail
  // | GoToAddBookingView
  | DeleteBooking
  | DeleteBookingSuccess
  | DeleteBookingFail
  // | EditBooking
  // | EditBookingSuccess
  // | EditBookingFail
  | ViewBookingDetail
  //
  | AddPersonalInfo
  | AddConferenceInfo
  | AddAccommodationInfo
  | AddRoomInfo
  | ResetCurrentBooking;



// WEBPACK FOOTER //
// /Users/abassey/side-proj/emp21-new/src/app/store/actions/booking.action.ts